/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'icap-nsx-defender-logs';
const prefix = `${moduleName}.${componentName}`;

export const nsxDefenderHeaderLabel = `${prefix}.nsxDefenderHeaderLabel`;
export const scoreLabel = `${prefix}.scoreLabel`;
export const taskIdLabel = `${prefix}.taskIdLabel`;
export const detailAnalysisLabel = `${prefix}.detailAnalysisLabel`;

export const ENGLISH = {
    [nsxDefenderHeaderLabel]: 'NSX Defender',
    [scoreLabel]: 'Score',
    [taskIdLabel]: 'Task ID',
    [detailAnalysisLabel]: 'Detail Analysis',
};
